








import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class Profile extends Vue {
  private output!: string

  get profileData () {
    const profileData = this.$store.getters['matrix/profileModel']
    this.output = this.syntaxHighlight(JSON.stringify(profileData, undefined, 4))
    return this.output
  }

  private syntaxHighlight (json: string) {
    json = json.replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
    return json.replace(
      /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)/g,
      (match) => {
        let cls = 'number'
        let clr = '#444'
        if (/^"/.test(match)) {
          if (/:$/.test(match)) {
            cls = 'key'
            clr = 'red'
          } else {
            cls = 'string'
            clr = 'green'
          }
        } else if (/true|false/.test(match)) {
          cls = 'boolean'
          clr = 'blue'
        } else if (/null/.test(match)) {
          cls = 'null'
          clr = 'magenta'
        }
        return '<span style="color:' + clr + '" class="' + cls + '">' + match + '</span>'
      }
    )
  }
}
